import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip";
import { Info } from "@phosphor-icons/react";

export const InfoTip = ({ text }) => (
  <TooltipProvider delayDuration={150}>
    <Tooltip>
      <TooltipTrigger asChild>
        <button type="button" data-testid="info-tip" aria-label="Explanation"
          className="text-muted-foreground/60 hover:text-foreground transition-colors duration-150 shrink-0">
          <Info size={13} weight="bold" />
        </button>
      </TooltipTrigger>
      <TooltipContent className="max-w-64 text-xs leading-relaxed">{text}</TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
